import { Text } from '@/components/shared/components/Text';

export const corporateIdNumberFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'cif',
    headerName: <Text tId={'CIF'} />,
    renderCell: (rowData) => (
      <div style={{ minWidth: '100px', display: 'flex', alignItems: 'center' }}>
        <div style={{ minWidth: '120px' }}>{rowData.row.registrationFields.corporateIdNumber}</div>
      </div>
    ),
  };
};
